module.exports = __webpack_public_path__ + "static/media/user_arrow_top_navbar_icon.811e3473.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user_arrow_top_navbar_icon.svg
// module id = 441
// module chunks = 1